import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthService } from '../../../../core/auth/services/auth.service';
import { HydrationHistoryGraphComponent } from '../hydration-history-graph/hydration-history-graph.component';
import { HydrationHistoryListComponent } from '../hydration-history-list/hydration-history-list.component';
import { HydrationDetailsService } from '../../hydration-service/hydration-details.service';
import {
  HydrationHistoryResponse,
  HydrationHistoryItem,
} from '../../hydration-const/hydration-details-models';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'patient-hydration-detail',
  standalone: true,
  imports: [CommonModule, HydrationHistoryGraphComponent, HydrationHistoryListComponent],
  templateUrl: './hydration-detail.component.html',
  styleUrl: './hydration-detail.component.css',
})
export class HydrationDetailComponent implements OnInit {
  patientId!: string;
  loading: boolean = true;
  historyData: HydrationHistoryItem[] = [];
  trackId!: string | null;

  private authService = inject(AuthService);
  private hydrationService = inject(HydrationDetailsService);
  private route = inject(ActivatedRoute);
  private router = inject(Router);

  ngOnInit(): void {
    this.trackId = history.state?.tracking_id;

    this.authService.getUserProfile().subscribe((res) => {
      if (res?.PatientId) {
        this.patientId = res.PatientId;
        this.getHydrationHistoryData();
      }
    });
  }

  getHydrationHistoryData() {
    this.loading = true;
    this.hydrationService.getHydrationHistory(this.patientId).subscribe({
      next: (res) => {
        if (res && res.status === 200 && res.history) {
          this.historyData = res.history;
        }
        this.loading = false;
      },
      error: (err) => {
        console.error('Failed to load hydration detail list data', err);
        this.loading = false;
      },
    });
  }

  onHydrationUpdated() {
    // Re-fetch data for the list when the modal updates something
    this.getHydrationHistoryData();
  }
}
